define('views/ecards/ecard_group',[
    'backbone',
    'views/_base/baseview',
    'text!views/ecards/ecard_group.html',
    'views/ecards/ecard_group_slider',
    'views/shared/modal/modal_component',
    'models/merchants/consumermerchantlocation'
], function(Backbone, BaseView, Template, EcardGroupSliderView, ModalComponent, MerchantLocationModel){
    'use strict';

    return BaseView.extend({
        className: 'account-egiftcard',
        tagName  : 'li',
        isRender : true,
        template : _.template(Template),
        events   : {
            'click .js-account-egiftcard'   : 'loadMerchantModel',
            'click .js-egiftcards-previous': 'showPreviousEcardMODAL',
            'click .js-egiftcards-next'    : 'showNextEcardMODAL',
            'click .js-pagination-item'    : 'handlePaginationTapMODAL',
            // 'click #pf-modal-close-btn'    : 'closeMODAL'
        },

        ecard_group_slider_view: null,

        initialize: function(options){
            options = options || {};

            this.data = options.data;
            this.header = options.header;
            this.wallet = options.wallet;
            this.wallet_view = options.wallet_view;
            this.loadEcards = options.loadEcards;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            this.$el.html(this.template());
        },

        loadMerchantModel: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            var that = this;

            this.merchant_model = new MerchantLocationModel({
                MGGD: this.data.key
            });

            this.merchant_model.fetch({
                success: function(model, resp){

                    that.showEcardGroupModal();

                },
                error: function(err){
                    // TODO: Handle error state
                }
            });

        },

        showEcardGroupModal: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            var that = this,
                merchant = this.merchant_model.toJSON();

            this.ecard_group_slider_view = new EcardGroupSliderView({
                data          : this.data,
                wallet        : this.wallet,
                header        : this.header,
                merchant      : merchant,
                loadEcards    : this.loadEcards,
                self_contained: true,
                calling_view_MODAL: this
            });
                
            var ecard_modal = new ModalComponent({
                show        : true, // True, if we want the modal to show itself when it's ready
                content     : this.ecard_group_slider_view,
                done        : function(){
                    console.log('ecard group done callback',this,that);
                },
                calling_view: this // Send in corresponding view to inherit events and custom properties
            });
        },

        handlePaginationTapMODAL: function(e){
            this.calling_view.ecard_group_slider_view.handlePaginationTap(e);
        },

        showPreviousEcardMODAL: function(){
            this.calling_view.ecard_group_slider_view.showPreviousEcard();
        },

        showNextEcardMODAL: function(){
            this.calling_view.ecard_group_slider_view.showNextEcard();
        },

        showEcardsMODAL: function(){
            console.log('showEcards ecard_group',this);
        },

        // closeMODAL: function(){
        //     $('#pf-modal-modern').fadeOut(function(){
        //         $('#pf-modal-modern').remove();
        //     });
        // },

        close: function(){}
    });
});
